module.exports = __webpack_public_path__ + "static/media/aadhaar.0744725f.png";